import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import styles from '../screens/EventsScreen.styles';

type PeriodType = 'today' | 'tomorrow' | 'week';

interface PeriodSelectorProps {
  value: PeriodType;
  onChange: (value: PeriodType) => void;
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({ value, onChange }) => {
  return (
    <View style={styles.periodSelector}>
      <TouchableOpacity
        style={[styles.periodButton, value === 'today' ? styles.periodButtonActive : styles.periodButtonInactive]}
        onPress={() => onChange('today')}
      >
        <Text style={[styles.periodButtonText, value === 'today' ? styles.periodButtonTextActive : styles.periodButtonTextInactive]}>Today</Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={[styles.periodButton, value === 'tomorrow' ? styles.periodButtonActive : styles.periodButtonInactive]}
        onPress={() => onChange('tomorrow')}
      >
        <Text style={[styles.periodButtonText, value === 'tomorrow' ? styles.periodButtonTextActive : styles.periodButtonTextInactive]}>Tomorrow</Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={[styles.periodButton, value === 'week' ? styles.periodButtonActive : styles.periodButtonInactive]}
        onPress={() => onChange('week')}
      >
        <Text style={[styles.periodButtonText, value === 'week' ? styles.periodButtonTextActive : styles.periodButtonTextInactive]}>This week</Text>
      </TouchableOpacity>
    </View>
  );
};


